/**
 * Created by Victor Rojo on 16/11/17.
 */
import {Component} from '@angular/core';

@Component({
  selector: 'tmpI18NComponent',
  moduleId: module.id,
  templateUrl: 'tmp.i18n.html'
})
export class TmpI18NComponent {
}
